"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentPreferences = void 0;
const infrastructure_1 = require("../../../infrastructure");
const PaymentSchedulingOption_1 = require("./PaymentSchedulingOption");
const utils_1 = require("@leavy/utils");
class PaymentPreferences extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.schedulingOption)
            && utils_1.Guard.Enum.isEnumMember(PaymentSchedulingOption_1.PaymentSchedulingOption)(this.schedulingOption));
    }
    toPlain() {
        return { ...this };
    }
}
exports.PaymentPreferences = PaymentPreferences;
//# sourceMappingURL=PaymentPreferences.js.map